<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.pushNotificationHistory')"
    resource="push_notification_histories"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/push_notification_histories.js';

@Component
export default class PushNotificationHistories extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'kind_eq',
      {
        prop: 'creator_id_eq',
        label: this.$t('model.adminUsersRole'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            xRemotePreload: async () => {
              const data = await this.$request.get('admin_users_roles/read_options', { page: 0 });
              return data.map((role) => ({ value: role.id, label: role.admin_user.email }));
            }
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      { key: 'kind', width: 200 },
      { key: 'all_users', width: 210 },
      {
        key: 'phones',
        renderCell: (h, { props: { value } }) => {
          return <span>{ value && value.length > 0 ? value.join(', ') : '' }</span>;
        }
      },
      'sent_count',
      'open_rates',
      {
        prop: 'creator',
        label: this.$t('model.adminUsersRole'),
        renderCell: (h, { props: { value } }) => {
          return <bean-link keepNode to={{ name: 'admin_users_roles.show', params: { id: value.id } }}>{value.admin_user.email}</bean-link>
        }
      },
      {
        prop: 'messages.en',
        label: this.$t('sms.enMessage'),
        renderCell: (h, { props: { value } }) => {
          if (value && type === 'index') {
            return <span>{value.length <= 20 ? value : `${value.slice(0, 20)}...`}</span>;
          } else {
            return <span style="white-space: pre-line">{value}</span>;
          }
        }
      },
      {
        prop: 'messages.fr',
        label: this.$t('sms.frMessage'),
        renderCell: (h, { props: { value } }) => {
          if (value && type === 'index') {
            return <span>{value.length <= 20 ? value : `${value.slice(0, 20)}...`}</span>;
          } else {
            return <span style="white-space: pre-line">{value}</span>;
          }
        }
      },
      { key: 'created_at', width: 120 },
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'push_notification_histories.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/push_notification_histories',
    name: 'push_notification_histories.index',
    component: PushNotificationHistories,
    props: {
      type: 'index',
    }
  },
  {
    path: '/push_notification_histories/:id',
    name: 'push_notification_histories.show',
    component: PushNotificationHistories,
    props: {
      type: 'show',
    }
  },
]
</script>
